import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import {Fragment, useCallback, useEffect, useState} from "react";
import Table from '../Table';
import SkeletonTableLoading from '../SkeletonTableLoading';
import api from "~/api/api";
function TablePaging({tablePagingConfig, reloadTable, ableSearch = true}) {
    const [tableState, setTableState] = useState({
        data: [],
        totalRecord: 0,
        totalPage: 1,
    });
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [searchString, setSearchString] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        const params = new URLSearchParams({
            PageSize: pageSize,
            PageNumber: pageNumber,
            searchString,
            ...(tablePagingConfig.extraParams || {})
        });

        api.get(`${tablePagingConfig.url}?${params}`)
            .then((res) => {
                const totalRecord = res.data.TotalRecord;
                const totalPage = totalRecord === 0 ? 1 : Math.ceil(totalRecord / pageSize);

                setTableState({
                    data: res.data.Results,
                    totalRecord,
                    totalPage,
                });
            })
            .catch((err) => {
                ;
            })
            .finally(() => {
                setLoading(false);
            })
    }, [pageSize, pageNumber, searchString, reloadTable]);

    const handlePrev = () => {
        console.log(pageNumber);
        if(pageNumber <= 1) return;
        console.log(pageNumber);
        setPageNumber(prev => prev - 1);
    };

    const handleNext = () => {
        if(pageNumber >= tableState.totalPage) return;
        setPageNumber(prev => prev + 1);
    };

    const handlePageClick = (page) => {
        if(page === pageNumber) return;
        setPageNumber(page);
    };

    const handleVisiblePages = () => {
        const { totalPage } = tableState;
        const pages = [];

        if (totalPage <= 7) {
            return Array.from({ length: totalPage }, (_, i) => i + 1);
        }

        pages.push(1);

        if (pageNumber > 4) {
            pages.push("...");
        }

        const start = Math.max(2, pageNumber - 1);
        const end = Math.min(totalPage - 1, pageNumber + 1);

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        if (pageNumber < totalPage - 3) {
            pages.push("...");
        }

        pages.push(totalPage);

        return pages;
    };


    const handleSearch = () => {
        setPageNumber(1);
        setSearchString(searchInput.trim());
    };

    const handleClear = () => {
        setPageNumber(1);
        setSearchInput("");
        setSearchString("");
    };

    return(
        <div data-list={""}>
            <div className="row g-2 align-items-center mb-2">
                <div className="col-auto d-flex align-items-center">
                    <label className="form-label me-2 ps-0" htmlFor="validationCustom04">Rows per page:</label>
                    <select className="form-select" style={{width: 'auto'}} value={pageSize} id="validationCustom04" required="" onChange={(e) =>{
                        setPageSize(e.target.value);
                        setPageNumber(1);
                    }}>
                        <option value='10'>10</option>
                        <option value='20'>20</option>
                        <option value='50'>50</option>
                        <option value='100'>100</option>
                        <option value='200'>200</option>
                    </select>
                </div>
                {
                    ableSearch && (
                    <div className="d-flex align-items-center search-box" style={{width: '500px'}} >
                        <div className="input-group">
                            <input name='search' className="form-control search-input search" type="search" placeholder="Search"
                                   aria-label="Search" value={searchInput} onChange={(e) =>{setSearchInput(e.target.value)}}
                                   onKeyDown={(e) => {e.key === "Enter" && searchInput !== "" && handleSearch()}}
                            />
                            <FontAwesomeIcon style={{zIndex: 10}} icon={faMagnifyingGlass} className="search-box-icon"/>
                            <button type="button" className="btn btn-bt-primary" onClick={handleSearch}>Search
                            </button>
                            <button type="button" className="btn btn-bt-primary" onClick={handleClear}>Clear
                            </button>
                        </div>
                    </div>
                    )
                }
            </div>
            {loading ? (
                <SkeletonTableLoading columns={tablePagingConfig.columns} rows={pageSize} />
            ) : (
                <Table tableConfig={{ ...tablePagingConfig, data: tableState.data }} />
            )}
            <div className="row align-items-center justify-content-between py-2 pe-0 fs-9">
                <div className="col-auto d-flex">
                    <p className="mb-0 d-none d-sm-block me-3 fw-semibold text-body" data-list-info="data-list-info">
                        {
                            tableState.totalRecord === 0 ? "No items" : <Fragment> {(pageNumber - 1) === 0 ? 1 : (pageNumber - 1)*pageSize} to {pageNumber*pageSize} <span className="text-body-tertiary"> Items of </span> {tableState.totalRecord} </Fragment>
                        }
                    </p>
                </div>
                <div className="col-auto d-flex">
                    <button className={`page-link ${pageNumber === 1 ? 'disabled' : ''}`} data-list-pagination="prev" onClick={handlePrev} disabled={pageNumber === 1} >
                        <FontAwesomeIcon icon={faChevronLeft}/>
                    </button>
                    <ul className="mb-0 pagination">
                        {
                            handleVisiblePages().map((page, index) => (
                                <li key={index} className={`${page === pageNumber ? "active" : ""} ${page === "..." ? "disabled" : ""}`}>
                                    <button onClick={() => handlePageClick(page)} className="page" type="button">{page}</button>
                                </li>
                            ))
                        }
                    </ul>
                    <button className={`page-link pe-0 ${pageNumber === tableState.totalRecord ? "disabled" : ""}`} data-list-pagination="next" onClick={handleNext} disabled={pageNumber === tableState.totalRecord} >
                        <FontAwesomeIcon icon={faChevronRight}/>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default TablePaging;